<template>
  <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
  name: "Injury"
}
</script>

<style scoped>

</style>